import { render, staticRenderFns } from "./PbcConfirmation.vue?vue&type=template&id=d64368b0&"
import script from "./PbcConfirmation.vue?vue&type=script&lang=js&"
export * from "./PbcConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports